import styled from "@emotion/styled";

import type { Option } from "./types";

export type ComboboxCollectionProps = {
  options: Option[];
  children: (option: Option, index: number) => React.ReactNode;
};

export function ComboboxCollection({ options, children }: ComboboxCollectionProps) {
  return (
    <CollectionContainer>
      {options.map((option, index) => {
        return children(option, index);
      })}
    </CollectionContainer>
  );
}

const CollectionContainer = styled.div({
  display: "flex",
  flexDirection: "column",
});
